const RDP_SLUGS = new Set<string>([
  'cloud-architect',
  'full-stack-developer',
  'network-engineer-architect',
  'video-game-developer',
  'human-resources-specialist',
  'data-scientist',
  'career-counselor',
  'software-developer-engineer',
  'logistics-supply-chain-analyst',
  'application-developer-engineer',
  'graphic-designer-desktop-publisher',
  'sales-operations-specialist',
  'user-interface-user-experience-ui-ux-designer',
  'content-creator',
  'communications-public-relations-specialist',
  'digital-marketing-specialist',
  'python-developer',
  'automation-engineer',
  'data-manager',
  'technical-support-engineer-analyst',
  'solutions-application-architect',
  'computer-support-specialist',
  'data-warehouse-developer',
  'tax-analyst-specialist',
  'personal-trainer-fitness-instructor',
  'network-systems-administrator',
  'video-game-designer',
  'payroll-specialist',
  'real-estate-agent',
  'back-end-developer-engineer',
  'ios-developer-engineer',
  'devops-engineer',
  'business-management-analyst',
  'sales-representative',
  'compensation-benefits-analyst',
  'program-manager',
  'sales-development-representative',
  'bookkeeper-accounting-clerk',
  'product-manager',
  'data-analyst',
  'cyber-security-engineer',
  'data-architect',
  'mainframe-developer',
  'scrum-master',
  'customer-service-representative',
  'social-media-strategist-specialist',
  'technology-consultant',
  'medical-office-manager',
  'data-engineer',
  'marketing-analytics-specialist',
  'cyber-security-specialist-technician',
  'front-end-developer',
  'statistician',
  'it-project-manager',
  'business-analyst-general',
  'machine-learning-engineer',
  'project-manager',
  'cyber-security-analyst',
  'business-intelligence-analyst',
  'android-developer-engineer',
]);

// Determines if a role slug corresponds to an RDP (Role Description Page) as of 2025/08/13
export default function isRdpSlug(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return RDP_SLUGS.has(slug);
}
